import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Theme = "system" | "light" | "dark";

type ThemeState = {
	theme: Theme;
	setTheme: (theme: Theme) => void;
};

export const getResolvedTheme = (theme: Theme): "light" | "dark" =>
	theme === "system"
		? window.matchMedia("(prefers-color-scheme: dark)").matches
			? "dark"
			: "light"
		: theme;

const applyTheme = (theme: Theme) => {
	document.documentElement.dataset.theme = getResolvedTheme(theme);
};

export const useThemeStore = create<ThemeState>()(
	persist(
		(set) => ({
			theme: "system",
			setTheme: (theme) => {
				set({ theme });
				applyTheme(theme);
			},
		}),
		{
			name: "theme-storage",
		},
	),
);

export const initTheme = () => {
	applyTheme(useThemeStore.getState().theme);

	window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
		if (useThemeStore.getState().theme === "system") {
			applyTheme("system");
		}
	});
};
